import { render } from "./pageView.vue?vue&type=template&id=4b1a249a&scoped=true"
const script = {}

import "./pageView.vue?vue&type=style&index=0&id=4b1a249a&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b1a249a"]])

export default __exports__